import React from 'react'
import "./TextCentered.css"

export default function TextCentered() {
  return (
    <div className='text-centered__container'>
    <h2>I want to personally help with the art of selling to help you design your own path to success</h2>
    </div>
  )
}
